module.exports = __webpack_public_path__ + "static/media/meeting.6b57b3b4.svg";